<template>
    <div class="conferencePage" v-if="data && data.page">
        <article>
            <div class="body">
                <BlockBody :body="data.page.body" />
                <div class="hosts" v-if="data.page.hosts">
                    <ItemPerson v-for="host in data?.page.hosts" :person="host.conferences_hosts_id" />
                </div>
            </div>
        </article>
        <WebsiteFooter />
    </div>
</template>

<script lang="ts" setup>
const { getConferenceOverview } = useConferences();
const route = useRoute()
const { data } = useAsyncData(`conferences-${route.params.slug}-overview`, () => getConferenceOverview(route.params.slug));

useSeoMeta({
    title: () => `${data.value?.page?.title} | Conferences | EIC Federation`,
    ogTitle: () => `${data.value?.page?.title} | Conferences | EIC Federation`,
    twitterTitle: () => `${data.value?.page?.title} | Conferences | EIC Federation`
})
</script>

<style lang="scss" scoped>
.conferencePage {
    article {
        padding: 0 var(--size-margin-page);

        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: var(--size-gutter-double) var(--size-margin-page);

        .body {
            grid-column: 2;

            .hosts {
                max-width: var(--text-maxwidth-body);

                display: grid;
                grid-template-columns: repeat(2, minmax(0, 1fr));
                gap: var(--size-gutter-double) var(--size-margin-page);
            }
        }
    }
}

@media screen and (max-width: 1024px) {
    .conferencePage {
        article {
            display: flex;
            flex-direction: column;
        }
    }
}
</style>